import React, { useState, useEffect } from 'react';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import euFlag from './euflag.png';
import './DocumentList.css';

const DocumentList = () => {
    const [documents, setDocuments] = useState([]);
    const { t } = useTranslation();

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_BASE_URL}/GetAllEuroDocumentFile`)
            .then(response => response.json())
            .then(data => {
                if (data.success && data.data) {
                    setDocuments(data.data);
                }
            })
            .catch(error => console.error('Error fetching documents:', error));
    }, []);

    const openDocument = (path) => {
        window.open(path, '_blank');
    };

    return (
        <div className="euro-doc-container">
            <div className="euro-doc-header">
                <img src={euFlag} alt="EU Flag" className="euro-doc-flagImage" />
                <h1>{t("ევროინტეგრაცია")}</h1>
            </div>
            <ul className="euro-doc-list">
                {documents.map(doc => (
                    <li key={doc.id} className="euro-doc-listItem" onClick={() => openDocument(doc.path)}>
                        {i18n.language === 'geo' ? doc.name : doc.nameEng}
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default DocumentList;
